import React, { useContext, useCallback } from 'react';
import { PageContext } from '../context';
import PageLayout from '../../shared/PageLayout';
import BookingType from './BookingType';
import BookingDate from './BookingDates';
import BookingGuests from './BookingGuests';
// import BookingPayment from './BookingPayment';
import BookingQuestions from './BookingQuestions';
import BookingSuccess from './BookingSuccess';
import BookingConfirm from './BookingConfirm';
import Loading from '../../../components/Loading';
import { LPTitle, LPText } from '../../styles';

const BookingPageContent = () => {
  const context = useContext(PageContext);
  const {
    currentStep, goToStep, queryLoading, queryError, queryData,
  } = context;

  const handleBackBtnClick = useCallback(() => {
    goToStep(currentStep - 1);
  }, [currentStep, goToStep]);

  if (queryLoading) {
    return (
      <PageLayout isDark>
        <Loading />
      </PageLayout>
    );
  }

  if (queryError) {
    return (
      <PageLayout isDark>
        <LPTitle> Oops! something went wrong: </LPTitle>
        <LPText>{queryError.message}</LPText>
      </PageLayout>
    );
  }

  if (!queryData) {
    return (
      <PageLayout isDark>
        <LPTitle> Oops! something went wrong: </LPTitle>
        <LPText>Could not get data</LPText>
      </PageLayout>
    );
  }

  const {
    getVpn: { account, bookingLandingPage },
  } = queryData;

  if (!bookingLandingPage) {
    return (
      <PageLayout isDark>
        <LPTitle> Oops! something went wrong: </LPTitle>
        <LPText> Nothing Found </LPText>
      </PageLayout>
    );
  }

  const { avatarMedia, subtitle, title } = bookingLandingPage;
  const { isVerified, coverMedia } = account;

  // TODO: Replace this stupid hack
  const names = title.split(' ');
  const firstName = names[0];
  const lastName = names[1];

  const morikawaImg = 'https://golfdigest.sports.sndimg.com/content/dam/images/golfdigest/fullset/2020/04/13/5e94b9f418447fde1f318495_200413-collin-morikawa.jpg.rend.hgtvcom.966.725.suffix/1587139337018.jpeg';

  const accountData = {
    avatarImg: (avatarMedia && avatarMedia.uri) || morikawaImg,
    firstName,
    lastName,
    description: subtitle,
    isVerified,
  };

  return (
    <PageLayout
      coverMedia={coverMedia}
      hasBackBtn={currentStep > 0 && currentStep < 4}
      onBackBtnClick={handleBackBtnClick}
      isDark
      showUserInfo
      account={accountData}
    >
      {currentStep === 0 && <BookingType />}
      {currentStep === 1 && <BookingDate />}
      {currentStep === 2 && <BookingGuests />}
      {currentStep === 3 && <BookingQuestions />}
      {/* {currentStep === 4 && <BookingPayment />} */}
      {currentStep === 4 && <BookingConfirm />}
      {currentStep === 5 && <BookingSuccess />}
    </PageLayout>
  );
};

BookingPageContent.propTypes = {};

export default BookingPageContent;
